import { Input } from '../Input'
import { StyleFn } from '..'

export const Textarea: StyleFn = (theme) => {
  const { root, _valid, _invalid } = Input(theme)

  return {
    root: {
      ...root,
      display: 'block',
      height: 'auto',
      resize: 'vertical',
      minWidth: '100%',
      maxWidth: '100%',
      '&:not([rows])': {
        maxHeight: '40rem',
        minHeight: '8rem',
      },
    },
    _valid,
    _invalid,
  }
}
